import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, finalize, timeout } from 'rxjs/operators';
import { LoadingIndicatorService } from '#services';

export const httpLoadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingIndicatorService = inject(LoadingIndicatorService);

  // Only track API calls
  const isApiCall = req.url.includes('/api');

  if (isApiCall) {
    loadingIndicatorService.incrementRequests();
  }

  return next(req).pipe(
    timeout(30_000), // 30 second timeout
    catchError((error) => throwError(() => error)),
    finalize(() => {
      if (isApiCall) {
        loadingIndicatorService.decrementRequests();
      }
    }),
  );
};
